import React from "react";
import "./StepTwo.css";
import { Button, Typography } from "@mui/material";
import { stepTwoData } from "../stepsData.js";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import tongueOut from "../../../../../Assets/Images/tongue-out.webp";

const StepTwo = () => {
  return (
    <>
      <div className="step-two mt-2 ">
        <Typography
          sx={{
            fontSize: "23.8532px",
            color: "#1F1F1F",
            fontFamily: "'Archivo', sans-serif",
          }}
          className="archivo fw-bold"
        >
          {stepTwoData[0].stepTwoHeading}
        </Typography>
        <div>
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              color: "#1F1F1F",
              fontFamily: "'Archivo', sans-serif",
            }}
            className="archivo mt-2"
          >
            {stepTwoData[0].paraOne}
          </Typography>
          <ul
            style={{ listStyle: "disc", fontSize: 16, color: "#1f1f1f" }}
            className=" archivo"
          >
            {stepTwoData[0].financialHealthList &&
              stepTwoData[0].financialHealthList.map((item, index) => (
                <li key={index}>
                  <strong>{item.head}</strong> {item.info}
                </li>
              ))}
          </ul>
        </div>

        <div className="tips mt-4 ">
          <div id="border_line"></div>
          <div id="tip__container" className="px-2 px-sm-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flex flex-row gap-2 align-items-center">
                <img src={tongueOut} alt="" style={{ width: 30, height: 30 }} />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    // color: "yellow",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  MinEmi Tip:
                </Typography>
              </div>
              <div className="mt-2">
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#1F1F1F",
                    // color: "#f8f8f8",

                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  {stepTwoData[0].tip}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Button
        sx={{
          textTransform: "none",
          margin: "0px",
          fontSize: 16,
          fontFamily: "'Archivo', sans-serif",
        }}
        onClick={() => {
          window.scroll(0, 0);
        }}
        className="d-flex algin-items-center archivo mt-3"
      >
        <FontAwesomeIcon icon={faArrowUp} /> &nbsp; Back To Top
      </Button>
    </>
  );
};

export default StepTwo;
